import _ from 'lodash';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

export function getThresholdsTooltip(degraded, excessive) {
    return `${i18n._(t`Thresholds`)}:
${i18n._(t`Degraded`)}: ${degraded}
${i18n._(t`Excessive`)}: ${excessive}
`;
}

export function getThresholds(test) {
    const testThresholds = test?.thresholds || [];
    const thresholds = _.cloneDeep(test?.typeNode?.thresholds || []);

    if (testThresholds.length > 0 && thresholds.length > 0) {
        thresholds.forEach((threshold) => {
            _.merge(threshold, _.find(testThresholds, { metricIds: _.chain(threshold).get('metricIds').value() }));
        });
    }

    return thresholds;
}

export function getThresholdsKeys(metricName, test) {
    const formattedMetricName = `avg${metricName}`;
    const thresholdMetrics = test?.typeNode?.thresholdInfo;
    const keys = {
        inverted: test?.typeNode?.thresholds?.[0]?.inverted || false,
    };

    if (!metricName) {
        return keys;
    }

    const metricId =
        test?.typeNode?.group === 'Web'
            ? 2
            : _.find(test?.typeNode?.metrics, (metric) => metric.name === metricName)?.id;
    const thresholdMetric = _.find(thresholdMetrics, (threshold) => threshold.metric === formattedMetricName);
    if (!thresholdMetric || thresholdMetric.length === 0) {
        return keys;
    }

    keys.critical = thresholdMetric.excessive;
    keys.degraded = thresholdMetric.degraded;
    keys.metricId = metricId;
    keys.inverted = thresholdMetric?.inverted || false;

    return keys;
}
